/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EClassModuleRecurrenceType } from "../types/EClassModuleRecurrenceType.ts";

/**
 * @description 1 = Weekly | 2 = Monthly |
 */
export const eClassModuleRecurrenceTypeSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe(
    "1 = Weekly | 2 = Monthly | ",
  ) as unknown as ToZod<EClassModuleRecurrenceType>;
